



















import Vue from 'vue';

export default Vue.extend({
	name: 'Jury',
	data: function(){
		return {}
	}
});
